import SellMarketingMessage from './messages';

const getSliderImages = (intl) => {
  const mapMarket = {
    img: '/c_scale,w_650/v1668616388/sell/price_compare.png',
    title: 'ComparePriceTitle',
    content: 'ComparePriceContent',
    name: 'COMPARE_PRICES',
    alt: intl.formatMessage(SellMarketingMessage.ComparePriceAlt)
  };
  return [mapMarket];
};

export {getSliderImages};
